export {default} from "@features/swing-trading/operator-screen";
